module.exports = __webpack_public_path__ + "img/selected2-min.9fb38b71.png";